const role = {
    super_admin:'super_admin',
    admin: 'admin',
    manager: 'manager',
    seller: 'seller',
    user: 'user',
    law_body: 'law_body',
    support: 'SUPPORT',
    fulfillment: 'FULFILLMENT',
    finance: 'FINANCE',
    seller_manager: 'MANAGER',
    procurement: 'PROCUREMENT',
    buyer_finance: 'BUYER_FINANCE',
    buyer_admin: 'ADMIN'
};

export default role;